import L from 'leaflet';
import Map from '../../providers/map-singleton';
import HttpService from '../../providers/http-service.js';
import moment from 'moment';
import { getConfig } from '../../config';

class ClusterPopup extends L.Popup {
    constructor(title, data, latLng, map) {
        super();
        this.map = map;
        this.setLatLng(latLng);
        this.title = title;
        this.config = getConfig();
        this.items = data;
        this.footerMsg = 'footerMsg';
        this.httpService = new HttpService();
        this.initSize(this.config);
        this.options.className = 'fort-map-popup';
        this.markup = this._getMarkup();
        this.setContent(this.markup);
        this.openOn(this.map);

        for (let item of this.items) {
            document.getElementsByClassName('object-cluster-item-' + item.object.real_id)[0]
                .onclick = this.clickItem.bind(this, item);
        }
        document.getElementsByClassName('object-cluster-popup-back')[0].onclick = this.clickBack;
    }

    initSize(config) {
        this.options.minWidth = config.popup.minWidth;
        this.options.maxHeight = config.popup.maxHeight;
    }

    clickBack() {
        let targetDiv3 = document.getElementsByClassName("object-cluster-popup-back")[0];

        targetDiv3.classList.add("displayNone");
        let targetDiv = document.getElementsByClassName("object-cluster-popup-container-group")[0];
        targetDiv.classList.remove("displayNone");

        var targetDiv2 = document.getElementById('object-cluster-popup-container').getElementsByClassName("item-info")[0];

        targetDiv2.parentNode.removeChild(targetDiv2);
    }

    clickItem(item) {
        let objectId = item.object.real_id;
        let event = new CustomEvent('tree:selectObject', { detail: { 'oid': objectId } });
        document.dispatchEvent(event);
        this.httpService.getData('/objectinfo?oid=' + objectId)
            .then(
                data => {
                    item.initPopup(data);
                    let itemPopupMarkup = item.popup._getMarkup();
                    var targetDiv = document.getElementsByClassName("object-cluster-popup-container-group")[0];
                    targetDiv.classList.add("displayNone");
                    var targetDiv2 = document.getElementsByClassName("object-cluster-popup-container")[0];
                    targetDiv2.insertAdjacentHTML('beforeend', itemPopupMarkup);
                    let targetDiv3 = document.getElementsByClassName("object-cluster-popup-back")[0];
                    targetDiv3.classList.remove("displayNone");
                },
                error => {  /*написать обработчик ошибки*/ }
            );
    }

    _getMarkup() {
        return `
            <div class="object-cluster-popup-container" id="object-cluster-popup-container">
                <div class="object-cluster-popup-back displayNone" style="color: #00a2d0; font-family: 'Roboto Light'; position: absolute; top: 10px; display: flex; align-items: center; cursor: pointer; z-index: 100">
                    <i class="fas fa-angle-left coloricon" style="font-family: fontawesome; font-style: initial; font-size: 34px; margin-right: 10px;"></i>
                    ${messages['Back']}
                </div>      
                <div class="object-cluster-popup-container-group x-panel x-border-item" style="margin: 45px 0px 0px 0px; height: calc(100% - 35px); overflow-y: auto;">
                    <div class="popup-title" style="text-align: center; text-align: center; position: fixed; z-index: 100; font-family: 'Roboto Regular'; width: 100%; top: 15px;">
                        ${messages['ElementsList']}
                    </div>  
                    <div class="x-panel-body x-panel-body-default x-panel-body-default x-noborder-trbl">       
                        <div class="x-grid-with-row-lines x-panel-body-default x-panel-body-default x-noborder-trbl">
                            <div class="x-grid-view x-grid-with-row-lines x-fit-item x-grid-view-default" style="padding: 10px 0px 15px 0px;">
                                <div class="x-grid-item-container group-items">
                                    <table class="object-popup-info-table" style="width: 100%;">          
                                        <tbody>                     
                                            ${this.items.sort(function (a, b) {
                                                if (a.name < b.name)
                                                    return -1;
                                                if (a.name > b.name)
                                                    return 1;
                                                return 0;
                                            }).map(item => this._renderRow(item)).join('')}
                                        </tbody>
                                    </table>
                                </div>     
                            </div>    
                        </div>
                    </div>
                </div>
            </div>
            </div>
        `;
    }

    _renderRow(item) {
        return `
            <tr class="object-info-row x-grid-row object-cluster-item-hover ${'object-cluster-item-' + item.object.real_id}" style="cursor: pointer">          
                <td class="x-grid-cell x-grid-td x-grid-cell-gridcolumn-1052" style="width: 80%; display: block;">
                    <div class="x-grid-cell-inner" style="text-align: left;">
                        ${item.name}
                    </div>
                </td>  
                <td class="x-grid-cell x-grid-td x-grid-cell-gridcolumn-1052" style="width: 25px; margin-left: auto; display: flex; align-items: center; justify-content: center;">
                    <div class="x-grid-cell-inner" style="text-align: left;max-width: 170px; display: flex; justify-content: center; align-items: center;">
                        ${item._getImageStatusMarkup(item.object.move)}
                    </div>
                </td>                 
                <td class="x-grid-cell x-grid-td x-grid-cell-gridcolumn-1052" style="width: 25px; display: flex; align-items: center; justify-content: center;">
                    <div class="x-grid-cell-inner" style="text-align: left; max-width: 170px; display: flex; justify-content: flex-start; align-items: center; width: 25px; height: 25px;">
                        ${item.getObjectStatus(item.object.status)}
                    </div>
                </td>
            </tr>
        `;
    }

    _getFooter(footerMsg) {
        return footerMsg;
    }
}

export default ClusterPopup;
